export const addHttps = (url: string): string => {
  const trimmed = url.trim()
  if (trimmed.startsWith('https://') || trimmed.startsWith('http://')) {
    return trimmed
  }
  return 'https://' + trimmed
}

export const getURLFromString = (url: string): URL | null => {
  try {
    const prepared = addHttps(url)
    return new URL(prepared)
  } catch (err) {
    console.error(err)
    return null
  }
}
